/**
 * 与「题目 → 界面呈现」相关的纯函数，前端与后端共用。
 *
 * 放在这里的原因是：一个题在界面上到底有哪些选项，取决于题型（固定选项 / 题组选项池 /
 * 题目自带选项）。渲染器要按它画控件，服务端校验「选项锚点」时也要按同一套规则判断
 * 这个选项是否真的存在——两份实现早晚会漂移，所以只留一份。
 */
import { FIXED_OPTIONS } from './constants.js';
/** 某个题在界面上实际渲染出来的选项池（顺序即渲染顺序）。 */
export function optionsForQuestion(question, group) {
    const fixed = FIXED_OPTIONS[question.kind];
    if (fixed)
        return question.options ?? fixed;
    if (question.kind === 'matching' || question.kind === 'matching_headings') {
        return group?.options ?? question.options ?? [];
    }
    return question.options ?? [];
}
//# sourceMappingURL=questions.js.map